export default __webpack_public_path__ + "static/media/back.58672507.svg";